// extracted by mini-css-extract-plugin
export default {"trophies":"Trophies--trophies--8Ltvy","list":"Trophies--list--Qf6To","listItem":"Trophies--listItem--RP9wx"};